<information-tag>
<div class="contents contents-wide">
  <section class="contents_area">
    <div class="container_heading">
      <h1 class="heading-01 heading_news">お知らせ</h1>
      <ul class="breadcrumb">
        <li class="breadcrumb-item"><a href="/menu" class="home">ホーム</a></li>
        <li class="breadcrumb-item">お知らせ</li>
      </ul>
    </div><!--/.container_heading-->
    
    <div class="table-nav_area">
      <div class="tab-menu">
        <ul class="tab-menu-list">
          <li class="tab-menu-list-item is-active"><a onclick={(e)=>limitService(e, '')}>全て</a></li>
          <li class="tab-menu-list-item"><a onclick={(e)=>limitService(e, 'croco-desk')}>CROCOデスク</a></li>
          <li class="tab-menu-list-item"><a onclick={(e)=>limitService(e, 'edilent')}>EDILENT</a></li>
          <li class="tab-menu-list-item"><a onclick={(e)=>limitService(e, 'system')}>運営</a></li>
        </ul>
      </div><!--/.tab-menu-->
      <div class="sort-menu">
        <select name="sort" id="sort" class="sort-list" onchange={(e)=>limitYear(e)}>
          <option value="">全て</option>
          <option value="2021">2021年</option>
          <option value="2020">2020年</option>
        </select>
      </div><!--/.sort-menu-->
    </div><!--/.table-nav_area-->
    <div class="table-nav_area">
      <p class="search_number">全{state.datainfo.total}件中　{state.datainfo.start}〜{state.datainfo.end}件</p>
    </div>
    <div class="tab_contents active" id="tab-01">
      <div class="contents_block" if={state.informations.length > 0}>
        <ul class="table_list">
          <li class="table_list-item list02" each={info in state.informations}>
            <span class="date">{info.created_at}</span>
            <span class="label {informationLabel(info.service)}"></span>
            <a onclick={(e)=>openMessage(e, info)}>{info.title}</a></li>
        </ul>
      </div><!--/.contents_block-->
      <div class="contents_block" if={state.informations.length == 0}>
        <p>お知らせはありません。</p>
      </div><!--/.contents_block-->

      <editech-hub-pagination-tag pager="{state.pager}" onpager="{(e,page)=>select(e,page)}" if={state.pager.last > 1}></editech-hub-pagination-tag>
      
    </div><!--/.table-nav_area-->	
  </section><!--/.contents_area-->
</div><!--/.contents-->

<script>
  import di from "dependeny-injection";
  import InformationLabel from "@model/information-label.js";
  export default {
    informationLabel: InformationLabel.get,
    state: {
      limitYear: '',
      limitService: '',
      info: {},
      informations: [],
      isLoading: true,
      page: 1,
      pager: {page: 1, total: 0, last: 0,  prev: 0, next: 0},
      datainfo: {total: 0, start: 0, end:0}
    },
    limitYear(e) {
      this.state.limitYear = e.target.value;
      this.state.page = 1;
      this.MenuApi.request('information', 'fetch', {service: this.state.limitService, year:this.state.limitYear})
      .then(data=>this.reload(data));

    },
    limitService(e, service){
      e.target.closest('ul').querySelectorAll('li').forEach(li=>li.classList.remove('is-active'));
      e.target.parentNode.classList.add('is-active');
      this.state.limitService = service;
      this.state.page = 1;
      this.MenuApi.request('information', 'fetch', {service: service, year: this.state.limitYear})
      .then(data=>this.reload(data));
    },
    openMessage(e, info){
      di.router.push(`/menu/information/detail/${info.id}`);
    },
    select(e, page) {
      e.preventDefault();
      this.state.page = page;
      this.MenuApi.request('information', 'fetch', {page: page, service: this.state.limitService, year: this.state.limitYear})
      .then(data=>this.reload(data));
    },
    reload(data){
      const start = 1 + ((data.page -1) * 10);
      this.update({
        informations: data.items,
        isLoading   : false,
        pager       : data,
        page        : data.page,
        datainfo    :{
          total: data.total,
          start: start,
          end: start + data.items.length - 1
      }
      });
    },
    onBeforeMount(props, state){
      this.MenuApi = di.createApi();
      this.MenuApi.request('information', 'fetch', {limit: props.limit, service: this.state.limitService, year: this.state.limitYear})
      .then(data=>this.reload(data));
    }
  }
</script>
</information-tag>
